<template>
  <div class="mdxx-control">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="tcf-notedit" v-if="!isauth">
          <div class="tcf-notedit-spinner">
            未授权小程序，<router-link to="/work/delxcxsz" class="a-txt">点击这里立即去授权</router-link>
          </div>
        </div>
        <div class="card-body">
          <div class="card-title">
            门店信息
          </div>
          <div v-loading="loading" class="card-content">
            <el-form v-if="loading==false" ref="shopinfo" :model="shopinfo" :rules="editRules" label-width="90px">
              <el-form-item label="门店名称" prop="name">
                <el-input v-model="shopinfo.name" maxlength="20" placeholder="例如：杭州乔金斯旗舰店" show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item label="首页样式" prop="indextype">
                <el-radio v-model="shopinfo.indextype" :label="1">
                  <el-image
                    style="width: 100px; height: 230px"
                    :src="index_style1"
                    fit="cover"></el-image>
                </el-radio>
                <el-radio v-model="shopinfo.indextype" :label="2">
                  <el-image
                    style="width: 100px; height: 230px"
                    :src="index_style2"
                    fit="cover"></el-image>
                </el-radio>
                <el-radio v-model="shopinfo.indextype" :label="3">
                  <el-image
                    style="width: 100px; height: 230px"
                    :src="index_style3"
                    fit="cover"></el-image>
                </el-radio>
              </el-form-item>
              <el-form-item label="LOGO" prop="logo">
                <span style="color:#99a9bf"><i class="el-icon-warning"></i> 建议上传1:1正方形图片</span>
                <SingleImg v-model="shopinfo.logo" :key="logokey" :oldurl="shopinfo.oldlogourl" />
              </el-form-item>
              <el-form-item label="门头图片" prop="img">
                <span style="color:#99a9bf"><i class="el-icon-warning"></i> 建议上传1:1正方形图片</span>
                <SingleImg v-model="shopinfo.img" :key="imgkey" :oldurl="shopinfo.oldimgurl" />
              </el-form-item>
              <el-form-item label="门店描述" prop="remark">
                <el-input v-model="shopinfo.remark" maxlength="300" show-word-limit type="textarea" :autosize="{ minRows: 3, maxRows: 3}"/>
              </el-form-item>
              <el-form-item label="电话" prop="tel">
                <el-input v-model="shopinfo.tel" maxlength="11" />
              </el-form-item>
              <el-form-item label="微信">
                <el-input v-model="shopinfo.wchat" maxlength="20" />
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input v-model="shopinfo.email" maxlength="60" />
              </el-form-item>
              <el-form-item label="所在地区" prop="city">
                <el-cascader
                  v-model="shopinfo.city"
                  style="width:100%"
                  :options="cityoptions"
                  filterable
                />
              </el-form-item>
              <el-form-item label="详细地址" prop="address">
                <el-input v-model="shopinfo.address" type="textarea" maxlength="200" :autosize="{ minRows: 3, maxRows: 3}" />
              </el-form-item>
              <el-form-item label="门店定位" prop="gps">
                <div style="color: #99a9bf"><i class="el-icon-info"></i> 点击地图位置或拖动坐标选择门店定位，有利于客户在小程序上精准导航至门店</div>
                <div style="color: #99a9bf">当前GPS经纬度：<b>{{shopinfo.gps[0]}},{{shopinfo.gps[1]}}</b></div>
                <div class="txmap"></div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="subLoading" @click="submitForm()">立即提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelShopInfo, updateDelShopInfo } from '@/api/dealer'
import { getCity } from '@/utils/city'
import { validatePhoneNumber } from '@/utils/validate'
import SingleImg from '@/components/upload/SingleImg'
import index_style1 from '@/assets/xcx/index_style1.jpg'
import index_style2 from '@/assets/xcx/index_style2.jpg'
import index_style3 from '@/assets/xcx/index_style3.jpg'
export default {
  name: 'delmdxx',
  components: {
    SingleImg
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validateCity = (rule, value, callback) => {
      if (this.shopinfo.city.length <= 0) {
        callback(new Error('请选择所在地区'))
      } else {
        callback()
      }
    }
    const validateGPS = (rule, value, callback) => {
      if (this.shopinfo.gps.length <= 0) {
        callback(new Error('请选择门店定位'))
      } else {
        callback()
      }
    }
    return {
      index_style1: index_style1,
      index_style2: index_style2,
      index_style3: index_style3,
      isauth: true,
      loading: true,
      subLoading: false,
      delid: '',
      logokey: '',
      imgkey: '',
      shopinfo: {
        name: '',
        remark: '',
        indextype: '',
        logo: {},
        img: {},
        tel: '',
        wchat: '',
        address: '',
        city: [],
        email: '',
        oldimgurl: '',
        gps: [],
        oldlogourl: ''
      },
      cityoptions: getCity(),
      editRules: {
        name: [{ required: true, message: '请输入门店名称', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入门店描述', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateUsername }],
        city: [{ required: true, trigger: 'change', validator: validateCity }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        indextype: [{ required: true, message: '请选择首页样式', trigger: 'change' }],
        logo: [{ required: true, message: '请上传门店LOGO', trigger: 'change' }],
        img: [{ required: true, message: '请上传门头图片', trigger: 'change' }],
        gps: [{ required: true, message: '请选择门店定位', trigger: 'change', validator: validateGPS }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.delid = this.user.delid
    this.getData()
  },
  methods: {
    initMap() {
      if (this.shopinfo.gps.length <= 0) {
        this.shopinfo.gps = [120.19005876947686, 30.193573919761388]
      }
      var that = this
      this.$nextTick(() => {
        const txmap = this.$el.querySelector('.txmap')
        if (txmap) {
          var center = new qq.maps.LatLng(that.shopinfo.gps[1], that.shopinfo.gps[0])
          var map = new qq.maps.Map(txmap, {
            center: center,
            zoom: 20
          })
          var anchor = new qq.maps.Point(35, 70),
            size = new qq.maps.Size(70, 70),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage('https://www.mulu.life/efile/upload/temp/map_marker.png', size, origin, anchor)
          var marker = new qq.maps.Marker({
            position: center,
            icon: icon,
            map: map,
            Draggable: true
          })
          qq.maps.event.addListener(marker, 'dragend', function() {
            var weizhi = marker.getPosition()
            that.shopinfo.gps = [weizhi.lng, weizhi.lat]
          })
          qq.maps.event.addListener(map, 'click', function(event) {
            that.shopinfo.gps = [event.latLng.getLng(), event.latLng.getLat()]
            var newcenter = new qq.maps.LatLng(that.shopinfo.gps[1], that.shopinfo.gps[0])
            marker.setPosition(newcenter)
          })
        }
      })
    },
    getData() {
      this.loading = true
      getDelShopInfo({ delid: this.delid }).then(response => {
        this.loading = false
        if (response.data !== null && response.data !== undefined) {
          if (response.data.appid === null || response.data.appid === '' || response.data.appid === undefined) {
            this.isauth = false
          }
          this.shopinfo.name = response.data.name
          this.shopinfo.remark = response.data.remark
          this.shopinfo.address = response.data.address
          this.shopinfo.indextype = response.data.indextype
          this.shopinfo.tel = response.data.tel
          this.shopinfo.wchat = response.data.wchat
          this.shopinfo.email = response.data.email
          if (response.data.lng !== null && response.data.lng !== undefined && response.data.lng !== '' && response.data.lat !== null && response.data.lat !== undefined && response.data.lat !== '') {
            this.shopinfo.gps = [response.data.lng, response.data.lat]
          } else {
            this.shopinfo.gps = []
          }
          this.shopinfo.logo = { imgid: response.data.logo, imgurl: response.data.logourl }
          this.shopinfo.img = { imgid: response.data.imgid, imgurl: response.data.imgurl }
          this.logokey = 'logo' + new Date().getTime()
          this.imgkey = 'img' + new Date().getTime()
          this.shopinfo.oldimgurl = response.data.imgurl
          this.shopinfo.oldlogourl = response.data.logourl
          this.initMap()
          const oldcity = []
          if (response.data.province) {
            oldcity.push(response.data.province)
          }
          if (response.data.province) {
            oldcity.push(response.data.city)
          }
          if (response.data.province) {
            oldcity.push(response.data.county)
          }
          if (oldcity.length > 0) {
            this.shopinfo.city = oldcity
          }
        } else {
          this.isauth = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submitForm() {
      this.$refs.shopinfo.validate((valid) => {
        if (valid) {
          if (!this.subLoading) {
            this.subLoading = true
            const data = {
              delid: this.delid,
              name: this.shopinfo.name,
              remark: this.shopinfo.remark,
              lng: this.shopinfo.gps[0],
              lat: this.shopinfo.gps[1],
              province: this.shopinfo.city[0],
              city: this.shopinfo.city[1],
              county: this.shopinfo.city[2],
              address: this.shopinfo.address,
              tel: this.shopinfo.tel,
              wchat: this.shopinfo.wchat,
              email: this.shopinfo.email,
              indextype: this.shopinfo.indextype,
              logo: this.shopinfo.logo.imgid,
              imgid: this.shopinfo.img.imgid
            }
            updateDelShopInfo(data).then(response => {
              this.$message({
                message: '经销商门店信息修改成功',
                type: 'success'
              })
              this.subLoading = false
              this.getData()
            }).catch(() => {
              this.subLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mdxx-control{
  .txmap{
    width: 100%;
    height: 400px;
  }
}
</style>
